const ENGLISH: 'en' = 'en';
const ARABIC: 'ar' = 'ar';

export default { ENGLISH, ARABIC };
